import { customAxios } from './customAxios'

export async function getAccountingAdv(filters) {
  const { body } = filters;

  const config = {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  };

  try {
    const res = await customAxios.post(
      `${process.env.REACT_APP_BACKEND_HOST}/${process.env.REACT_APP_PATH_NEW_PREFIX}/getAccountingAdv`,
      body,
      config
    );

    if (res.status === 200) {
      return res.data.body;
    }

    throw new Error(`Errore nella chiamata getAccountingAdv: ${res.status}`);
  } catch (err) {
    console.error('Errore in getAccountingAdv:', err);
    throw err;
  }
}
